import { jsxs as e, jsx as t } from "react/jsx-runtime";

import { format as a, parse as r } from "date-fns";

import { uniq as i, capitalize as o } from "lodash";

import { useState as l, useMemo as n, useCallback as s } from "react";

import { getScheduleIntervalTitle as m } from "../../../utils.js";

import d from "@ui-components-3/ui/lib/utils/classNames";

import c from "@ui-components-3/icons/lib/regular/Pencil";

import p from "@ui-components-3/icons/lib/regular/TrashCan";

import u from "@ui-components-3/icons/lib/regular/Calendar";

import f from "@ui-components-3/icons/lib/regular/CalendarDay";

import b from "@ui-components-3/icons/lib/regular/ClockRotateLeft";

import { useProviderSchedule as h } from "../../../hooks/useProviderSchedule.js";

import x from "../../DeleteAvailabilityModal/index.js";

import { useCreateAvailabilityFlow as y } from "../../../hooks/useCreateAvailability.js";

const g = ({schedule: g}) => {
    const {startDate: N, endDate: w, byweekday: C, id: D} = g || {}, {variantClassNames: j, deleteSchedule: k, isEditOrDeleteDisabled: v} = h(), {initFlow: M} = y(), [O, A] = l(!1), E = n((() => i([ N, w ].map((e => e ? a(new Date(e), "MM/dd/yy") : ""))).filter(Boolean).join(" - ") || ""), [ w, N ]), P = n((() => C ? C.map((e => a(r(o(e), "eeeeee", new Date), "eee"))).join("/") : a(new Date(N), "eeee")), [ C, N ]), S = n((() => m(g)), [ g ]), B = s((() => {
        A(!0);
    }), []), F = s((async () => {
        await k(D);
    }), [ k, D ]), L = s((() => {
        M(D);
    }), [ D, M ]);
    return e("div", {
        className: "typography-body-l flex flex-row items-start gap-2 rounded-2xl border border-neutral-300 bg-neutral-100 px-6 py-4 text-neutral-800",
        children: [ e("div", {
            className: "flex flex-1 flex-col gap-2",
            children: [ e("p", {
                className: d("flex flex-row items-center gap-2 font-semibold", j.textMain),
                children: [ t(u, {
                    "aria-hidden": "true",
                    className: "typography-body"
                }), E ]
            }), e("p", {
                className: "typography-body flex flex-row items-center gap-2 font-medium",
                children: [ t(f, {
                    "aria-hidden": "true",
                    className: j.textMain
                }), P ]
            }), e("p", {
                className: "typography-body flex flex-row items-center gap-2 font-medium",
                children: [ t(b, {
                    "aria-hidden": "true",
                    className: j.textMain
                }), S ]
            }) ]
        }), e("div", {
            className: "flex shrink-0 flex-row items-center gap-3",
            children: [ t("button", {
                type: "button",
                className: d("btn-sm bg-transparent px-0", j.buttonOutlined),
                "aria-label": "Edit schedule",
                onClick: L,
                disabled: v,
                children: t(c, {
                    "aria-hidden": "true"
                })
            }), t("button", {
                type: "button",
                className: d("btn-sm bg-transparent px-0", j.buttonOutlined),
                "aria-label": "Delete schedule",
                onClick: B,
                disabled: v,
                children: t(p, {
                    "aria-hidden": "true"
                })
            }) ]
        }), !!O && t(x, {
            onConfirm: F,
            onClose: () => A(!1)
        }) ]
    });
};

export { g as default };
//# sourceMappingURL=ScheduleItemCard.js.map
